<template>
    <ul class="nav nav-tabs">
        <slot></slot>
    </ul>
</template>

